import {BarcodeDetector,prepareZXingModule} from 'barcode-detector/pure';
import readerWasmUrl from 'zxing-wasm/reader/zxing_reader.wasm?url';

// Warehouse scans must use the version shipped with Portal, including when a CDN is unavailable.
prepareZXingModule({overrides:{locateFile:(path:string)=>path.endsWith('.wasm')?readerWasmUrl:path}});
export {BarcodeDetector};
